export const OPEN = 'open';
export const CLOSED = 'closed';
export const CLOSED_TEMPORARILY = 'closed_temporarily';
export const OPENING_SOON = 'opening_soon';
export const STATUSES = [OPEN, CLOSED, CLOSED_TEMPORARILY, OPENING_SOON];
export const ALL_STATUSES_EXCEPT_CLOSED = STATUSES.filter(status => status !== CLOSED).join(',');
